import { Button, IconFont, Input, tinyButtons } from '@byecode/ui'
import styled, { css } from 'styled-components'

export const Container = styled.div`
    height: 100%;
    min-height: 0;
    display: flex;
    flex-shrink: 0;
    flex-direction: column;
    width: 240px;
    border-right: 1px solid var(--color-gray-200);
    background-color: var(--color-white);
`

export const Content = styled.div`
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`

export const Header = styled.div`
    width: 100%;
    height: 36px;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`

export const SearchWrapper = styled.div`
    padding: 12px 12px 8px 12px;
    display: flex;
    flex-flow: nowrap row;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
`

export const ListWrapper = styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
`

export const Space = styled.div`
    width: 100%;
    height: 188px;
`

export const Search = styled(Input)``

export const SearchIcon = styled(IconFont)``

export const GroupName = styled.div`
    color: var(--color-gray-400);
    font-size: 12px;
`

export const List = styled.div`
    position: relative;
    width: 100%;

    ${tinyButtons}
`

export const LinkInfo = styled.div`
    color: var(--color-white);
    font-size: var(--font-size-sm);
    text-align: left;
`

export const Link = styled(Button)``

export const LinkIcon = styled(IconFont)``
